import { render, staticRenderFns } from "./ViewKioskOrder.vue?vue&type=template&id=2733e352&scoped=true"
import script from "./ViewKioskOrder.vue?vue&type=script&lang=js"
export * from "./ViewKioskOrder.vue?vue&type=script&lang=js"
import style0 from "./ViewKioskOrder.vue?vue&type=style&index=0&id=2733e352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2733e352",
  null
  
)

export default component.exports